// layout blocks
import NavigationBlock from './layout-blocks/NavigationBlock';
import HeroBlock from './layout-blocks/HeroBlock';
import HeroLandingBlock from './layout-blocks/HeroLandingBlock';
import LightBlock from './layout-blocks/LightBlock';
import DarkBlock from './layout-blocks/DarkBlock';
import FooterBlock from './layout-blocks/FooterBlock';
import HeroCampaignBlock from './layout-blocks/HeroCampaignBlock';

// navigation
import MenuItemBlockLinks from './navigation/MenuItemBlockLinks';
import MenuItemBlockHelp from './navigation/MenuItemBlockHelp';
import MenuItemBlockDirectLink from './navigation/MenuItemBlockDirectLink';

// components
import FeaturesCardsContainer from './components/FeaturesCardsContainer';
import FeaturesSmallCardsContainer from './components/FeaturesSmallCardsContainer';
import BannerBlock from './components/BannerBlock';
import CtaContainer from './components/CtaContainer';
import Columns from './components/Columns';
import TextBlock from './components/TextBlock';
import SquaresBlock from './components/SquaresBlock';
import ImageBlock from './components/ImageBlock';
import ImageBoxBlock from './components/ImageBoxBlock';
import DynamicBlock from './components/DynamicBlock';
import IconsList from './components/IconsList';
import H1 from './components/H1';
import H2 from './components/H2';
import H4 from './components/H4';
import H5 from './components/H5';
import HorizontalSpace from './components/HorizontalSpace';
import TestimonialsBlock from './components/TestimonialsBlock';
import TestimonialsCarousel from './components/TestimonialsCarousel';
import FullImageCtaBlock from './components/FullImageCtaBlock';
import SmsHeroBlock from './components/SmsHeroBlock';
import Line from './components/Line';
import ReferencesBlock from './components/ReferencesBlock';
import ReferencesCarousel from './components/ReferencesCarousel';
import ClaimWithNumber from './components/ClaimWithNumber';
import ColumnsImageWithTextBlock from './components/ColumnsImageWithTextBlock';
import QuestionsBlock from './components/QuestionsBlock';
import Block from './components/Block';
import FeaturesSimpleCardsContainer from './components/FeaturesSimpleCardsContainer';
import FeaturesNumberedCardsContainer from './components/FeaturesNumberedCardsContainer';
import Buttons from './components/Buttons';
import SmsCaseStudyCarousel from './components/SmsCaseStudyCarousel';
import RichTextBlock from './components/RichTextBlock';
import RichTextMarkdownBlock from './components/RichTextMarkdownBlock';
import HtmlBlock from './components/HtmlBlock';
import SmsPricingCardsBlock from './components/SmsPricingCardsBlock';
import ImagesCarousel from './components/ImagesCarousel';
import FeaturesHighlightGallery from './components/FeaturesHighlightGallery';
import CardsWithImageBlock from './components/CardsWithImageBlock';
import SimpleTable from './components/SimpleTable';
import PricingBlock from './components/PricingBlock';
import SharedComponent from './components/SharedComponent';
import StatsTable from './components/StatsTable';
import CaseStudiesBlock from './components/CaseStudiesBlock';
import CookiesBlock from './components/CookiesBlock';
import Testimonial from './components/Testimonial';
import ClientLineBlocks from './components/ClientLineBlocks';
import PlatformsStrip from './components/PlatformsStrip';
import TutorialsBlock from './components/TutorialsBlock';
import WebinarsBlock from './components/WebinarsBlock';
import UpcomingWebinarsBlock from './components/UpcomingWebinarsBlock';
import MaterialsBlock from './components/MaterialsBlock';
import HowItWorksCarousel from './components/HowItWorksCarousel';
import TimelineCarousel from './components/TimelineCarousel';
import SegmentationBlock from './components/SegmentationBlock';
import QuizBlock from './components/QuizBlock';
import GlossaryListBlock from './components/GlossaryListBlock';

// glossary detail components (dynamic zone on glossary-term)
import GlossaryRichText from './components/glossary/GlossaryRichText';
import GlossaryTable from './components/glossary/GlossaryTable';
import GlossaryCallout from './components/glossary/GlossaryCallout';
import GlossarySegmentsShowcase from './components/glossary/GlossarySegmentsShowcase';
import GlossaryInlineCta from './components/glossary/GlossaryInlineCta';
import GlossaryFaq from './components/glossary/GlossaryFaq';
import GlossaryCtaDark from './components/glossary/GlossaryCtaDark';

export const LAYOUT_BLOCKS = 'layout-blocks';
export const COMPONENTS = 'components';
export const NAVIGATION = 'navigation';
export const GLOSSARY = 'glossary';

const components = {
  [LAYOUT_BLOCKS]: {
    ComponentLayoutBlocksNavigationBlock: NavigationBlock,
    ComponentLayoutBlocksHeroBlock: HeroBlock,
    ComponentLayoutBlocksHeroLandingBlock: HeroLandingBlock,
    ComponentLayoutBlocksLightBlock: LightBlock,
    ComponentLayoutBlocksDarkBlock: DarkBlock,
    ComponentLayoutBlocksFooterBlock: FooterBlock,
    ComponentLayoutBlocksHeroCampaignBlock: HeroCampaignBlock
  },
  [COMPONENTS]: {
    ComponentComponentsFeaturesCardsContainer: FeaturesCardsContainer,
    ComponentComponentsFeaturesSmallCardsContainer: FeaturesSmallCardsContainer,
    ComponentComponentsBannerBlock: BannerBlock,
    ComponentComponentsCtaContainer: CtaContainer,
    ComponentComponentsColumns: Columns,
    ComponentComponentsTextBlock: TextBlock,
    ComponentComponentsSquaresBlock: SquaresBlock,
    ComponentComponentsImageBlock: ImageBlock,
    ComponentComponentsImageBoxBlock: ImageBoxBlock,
    ComponentComponentsH1: H1,
    ComponentComponentsH2: H2,
    ComponentComponentsH4: H4,
    ComponentComponentsH5: H5,
    ComponentComponentsDynamicBlock: DynamicBlock,
    ComponentComponentsIconsList: IconsList,
    ComponentComponentsHorizontalSpace: HorizontalSpace,
    ComponentComponentsTestimonialsBlock: TestimonialsBlock,
    ComponentComponentsTestimonialsCarousel: TestimonialsCarousel,
    ComponentComponentsFullImageCtaBlock: FullImageCtaBlock,
    ComponentComponentsSmsHeroBlock: SmsHeroBlock,
    ComponentComponentsLine: Line,
    ComponentComponentsReferencesBlock: ReferencesBlock,
    ComponentComponentsReferencesCarousel: ReferencesCarousel,
    ComponentComponentsClaimWithNumber: ClaimWithNumber,
    ComponentComponentsColumnsImageWithTextBlock: ColumnsImageWithTextBlock,
    ComponentComponentsQuestionsBlock: QuestionsBlock,
    ComponentComponentsBlock: Block,
    ComponentComponentsFeaturesSimpleCardsContainer: FeaturesSimpleCardsContainer,
    ComponentComponentsFeaturesNumberedCardsContainer: FeaturesNumberedCardsContainer,
    ComponentComponentsButtons: Buttons,
    ComponentComponentsSmsCaseStudyCarousel: SmsCaseStudyCarousel,
    ComponentComponentsRichText: RichTextBlock,
    ComponentComponentsRichTextMarkdown: RichTextMarkdownBlock,
    ComponentComponentsHtmlBlock: HtmlBlock,
    ComponentComponentsSmsPricingCardsBlock: SmsPricingCardsBlock,
    ComponentComponentsImagesCarousel: ImagesCarousel,
    ComponentComponentsFeaturesHighlightGallery: FeaturesHighlightGallery,
    ComponentComponentsCardsWithImageBlock: CardsWithImageBlock,
    ComponentComponentsSimpleTable: SimpleTable,
    ComponentComponentsPricingBlock: PricingBlock,
    ComponentComponentsSharedComponent: SharedComponent,
    ComponentComponentsStatsTable: StatsTable,
    ComponentComponentsCaseStudiesBlock: CaseStudiesBlock,
    ComponentComponentsCookiesBlock: CookiesBlock,
    ComponentComponentsTestimonials: Testimonial,
    ComponentComponentsClientLineBlocks: ClientLineBlocks,
    ComponentComponentsPlatformsStrip: PlatformsStrip,
    ComponentComponentsTutorialsBlock: TutorialsBlock,
    ComponentComponentsWebinarsBlock: WebinarsBlock,
    ComponentComponentsUpcomingWebinarsBlock: UpcomingWebinarsBlock,
    ComponentComponentsMaterialsBlock: MaterialsBlock,
    ComponentComponentsHowItWorksCarousel: HowItWorksCarousel,
    ComponentComponentsTimelineCarousel: TimelineCarousel,
    ComponentComponentsSegmentationBlock: SegmentationBlock,
    ComponentComponentsQuizBlock: QuizBlock,
    ComponentComponentsGlossaryListBlock: GlossaryListBlock
  },
  [NAVIGATION]: {
    ComponentNavigationMenuItemBlockLinks: MenuItemBlockLinks,
    ComponentNavigationMenuItemBlockHelp: MenuItemBlockHelp,
    ComponentNavigationMenuItemBlockDirectLink: MenuItemBlockDirectLink
  },
  [GLOSSARY]: {
    ComponentComponentsRichTextMarkdown: GlossaryRichText,
    ComponentGlossaryTable: GlossaryTable,
    ComponentGlossaryCallout: GlossaryCallout,
    ComponentGlossarySegmentsShowcase: GlossarySegmentsShowcase,
    ComponentGlossaryInlineCta: GlossaryInlineCta,
    ComponentGlossaryFaq: GlossaryFaq,
    ComponentGlossaryCtaDark: GlossaryCtaDark
  }
};

export default components;
